module.exports = __webpack_public_path__ + "resources/img/img-manufacturing-fems-m-en.f6881a347adce5f7888a72ee6c63b728.png";